import { Component } from 'react';
import styled from '@emotion/styled';

// Components
import CTAButton from "../../../CTAButton"

const WidgetBody = styled.div`
  background-image: url(${props => props.backgroundImageUrl});
  background-position: center top;
  background-repeat: no-repeat;
  background-size: cover;
  display: inline-block;
  padding: 6em 1em 1em;
  position: relative;
  width: 100%;

  @media (max-width: 480px) {
    background-size: 200%;
    padding-top: 5.25em;
  }
`;

const RoofingDiagram = styled.div`
  background-image: url(${props => props.imageUrl});
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
  display: inline-block;
  height: 82%;
  position: absolute;
  right: -30%;
  top: 52%;
  transform: translateY(-50%);
  width: 92%;

  @media (max-width: 600px) {
    height: 68%;
    right: -29%;
    width: 82%;
  }

  @media (max-width: 480px) {
    height: auto;
    margin-bottom: 1em;
    padding-bottom: 75%;
    position: relative;
    right: auto;
    transform: none;
    width: 100%;
  }
`;

const WidgetContent = styled.div`
  display: inline-block;
  max-width: 375px;
  min-height: 32em;
  padding: 1em 1em 4.4em;
  position: relative;
  width: 80%;

  @media (max-width: 600px) {
    max-width: 320px;
    min-height: 28em;
    padding-bottom: 4em;
  }

  @media (max-width: 480px) {
    min-height: 13.5em;
    padding-bottom: 3.6em;
    width: 100%;
  }
`;

const Icon = styled.div`
  background-image: url(${props => props.iconUrl});
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
  height: 3em;
  margin-bottom: 1.5em;
  width: 3em;

  @media (max-width: 480px) {
    height: 2.786em;
    margin-top: -5em;
    width: 2.786em;
  }
`;

const WidgetHeading = styled.div`
  font-size: 2.222em;
  font-weight: 700;
  line-height: 120%;
  margin-bottom: 0.5em;

  @media (max-width: 600px) {
    font-size: 2em;
  }

  @media (max-width: 480px) {
    font-size: 1.375em;
  }
`;

const Paragraph = styled.p`
  line-height: 150%;
  margin-bottom: 2em;
  position: relative;
`;

const MainCta = styled(CTAButton)`
  align-items: center;
  background-color: #000000;
  border: 2px solid #000000;
  color: #FFFFFF;
  cursor: pointer;
  display: inline-flex;
  font-size: 0.778em;
  line-height: 1.2;
  padding: 0.6em 1em;
  position: relative;
  text-transform: uppercase;
  text-decoration: none;

  @media (max-width: 600px) {
    font-size: 0.875em;
  }

  @media (max-width: 480px) {
    font-size: 1em;
  }

  &:hover {
    color: #FFFFFF;
  }

  &:hover:before {
    border-color: #FFFFFF;
  }

  &:before {
    border: 2px solid transparent;
    bottom: 0;
    content: "";
    display: inline-block;
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
  }

  &:after {
    align-self: center;
    content: "";
    display: inline-block;
    font-family: icomoon;
    line-height: 1;
    margin-left: 1.4em;
    position: relative;
    transform: translateY(-10%);
  }

  bottom: 0;
  margin-bottom: 3em;
  position: absolute;

  @media (max-width: 600px) {
    margin-bottom: 2em;
  }

  @media (max-width: 480px) {
    margin-bottom: 1em;
  }
`;

export default class TPRSBody extends Component {
  render() {
    const {
      bodyImageUrl,
      roofImageUrl,
      iconUrl,
      title,
      paragraph,
      ctaText,
      clickEvent
    } = this.props;

    return (
      <WidgetBody backgroundImageUrl={bodyImageUrl}>
        <RoofingDiagram imageUrl={roofImageUrl} />
        <WidgetContent>
          {iconUrl &&
            <Icon iconUrl={iconUrl} />
          }
          <WidgetHeading>{title}</WidgetHeading>
          <Paragraph>{paragraph}</Paragraph>
          {(ctaText && clickEvent) &&
            <MainCta
              text={ctaText}
              onClick={clickEvent}
              data-track="learn-more"
              data-track-element-location="tprs-body"
              data-track-destination={ctaText}
            />
          }
        </WidgetContent>
      </WidgetBody>
    );
  }
}
